import React from 'react';

// Simple, consistent monochrome brand icons rendered as inline SVGs.
// Using currentColor so the parent's text color drives the fill.

export const XIcon = ({ size = 16, className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M18.244 2H21.5l-7.51 8.583L23 22h-6.828l-5.35-6.99L4.6 22H1.34l8.036-9.18L1 2h6.914l4.83 6.386L18.244 2zm-1.196 18h1.87L7.03 3.9H5.045l12.003 16.1z" />
  </svg>
);

export const InstagramIcon = ({ size = 16, className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

export const FacebookIcon = ({ size = 16, className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M13.5 22v-8h2.7l.4-3.2h-3.1V8.7c0-.9.3-1.6 1.6-1.6h1.6V4.2c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.4-4 4v2.7H7.6V14h2.7v8h3.2z" />
  </svg>
);

export const TikTokIcon = ({ size = 16, className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M16.5 2h-2.7v13.2a2.7 2.7 0 1 1-2.7-2.7c.3 0 .5 0 .8.1V9.9c-.3 0-.5-.1-.8-.1a5.4 5.4 0 1 0 5.4 5.4V8.9c1.1.8 2.5 1.3 4 1.3V7.5c-2.3 0-4-1.9-4-4V2z" />
  </svg>
);

export const RedditIcon = ({ size = 16, className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M22 12.1c0-1.2-1-2.2-2.2-2.2-.6 0-1.1.2-1.5.6-1.5-1-3.4-1.6-5.5-1.7l1-4.4 3.1.7c0 .8.6 1.4 1.4 1.4.8 0 1.5-.7 1.5-1.5S19.1 3.5 18.3 3.5c-.5 0-1 .3-1.3.7l-3.4-.8c-.2 0-.4.1-.4.3l-1.1 4.9c-2.1.1-4 .7-5.5 1.7-.4-.4-.9-.6-1.5-.6C3.9 9.7 3 10.7 3 11.9c0 .9.5 1.6 1.2 2-.1.3-.1.6-.1.9 0 3 3.6 5.5 8 5.5s8-2.5 8-5.5c0-.3 0-.6-.1-.9.7-.4 1.2-1.1 1.2-2zM8.4 13.3c0-.7.6-1.3 1.3-1.3s1.3.6 1.3 1.3-.6 1.3-1.3 1.3-1.3-.6-1.3-1.3zm7.4 3.5c-1.1.7-2.7.9-3.8.9s-2.7-.2-3.8-.9c-.2-.1-.3-.4-.2-.6.1-.2.4-.3.6-.2 1 .6 2.3.8 3.4.8s2.4-.2 3.4-.8c.2-.1.5 0 .6.2.1.2 0 .5-.2.6zm-.5-2.2c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3 1.3.6 1.3 1.3-.6 1.3-1.3 1.3z" />
  </svg>
);

export const DiscordIcon = ({ size = 16, className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M20.317 4.492a19.79 19.79 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.492a.07.07 0 0 0-.032.027C.533 9.093-.32 13.555.099 17.961a.082.082 0 0 0 .031.056 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.061 0a.074.074 0 0 1 .078.009c.12.098.245.196.372.293a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.094-.838-9.52-3.549-13.442a.061.061 0 0 0-.031-.028zM8.02 15.278c-1.182 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
  </svg>
);
